export enum EInitiativesDictionary {
  APP_SIGNUP = 'app-signup',
  DEFAULT = 'default',
  WIDGET_SIGNUP = 'widget-signup',
  LOYALTY_AND_REWARDS = 'loyalty-rewards',
  REFERRAL_PROGRAM = 'referral-program',
  FREE_COINS = 'free-coins',
  WELCOME_COINS = 'welcome-coins',
  DEALS_AND_DISCOUNTS = 'deals-discounts',
  BIRTHDAY_CLUB = 'birthday-club',
  GIFT_COINS = 'gift-coins',
  INVITATION_CAMPAIGN = 'invitation-campaign',
  CUSTOMER_ACQUISITION = 'customer-acquisition',
  SOCIAL_REWARDS = 'social-rewards',
  SPECIAL_COINS = 'special-coins',
  ACTIVE_PROGRAMS_REGULAR = 'active-programs-no-deadline',
  ACTIVE_PROGRAMS_WARNING = 'active-programs-with-deadline',

  // TODO: update file name (generic)
  PURCHASE_HISTORY_COMPLETED = 'completed',
  PURCHASE_HISTORY_PENDING = 'pending',
  PURCHASE_HISTORY_DISPUTED = 'disputed',
  PURCHASE_HISTORY_CANCELED = 'canceled',
  PURCHASE_HISTORY_WITH_REWARD_BONUS = 'withRewardBonus',

  SPECIAL_OFFER_STOREWIDE = 'storewide-deal',
  SPECIAL_OFFER_SPECIFIC = 'specific-product',
  SPECIAL_OFFER_BIRTHDAY = 'birthday-offer',

  TRANSPARENT_SPECIAL_OFFER_STOREWIDE = 'special-coins-storewide',
  TRANSPARENT_SPECIAL_OFFER_PRODUCT_SERVICE = 'special-coins-product-service',
  TRANSPARENT_SPECIAL_OFFER_BIRTHDAY = 'special-coins-birthday',
  TRANSPARENT_SPECIAL_OFFER_TWO_FOR_ONE = 'special-coins-two-for-one'
}

export const InitiativeLabelDictionary = {
  [EInitiativesDictionary.APP_SIGNUP]: 'App Sign Up',
  [EInitiativesDictionary.DEFAULT]: 'default',
  [EInitiativesDictionary.WIDGET_SIGNUP]: 'Widget Signup',
  [EInitiativesDictionary.LOYALTY_AND_REWARDS]: 'Loyalty & rewards',
  [EInitiativesDictionary.REFERRAL_PROGRAM]: 'Referral program',
  [EInitiativesDictionary.FREE_COINS]: 'Free Coins',
  [EInitiativesDictionary.WELCOME_COINS]: 'Welcome Coins',
  [EInitiativesDictionary.DEALS_AND_DISCOUNTS]: 'Deals & discounts',
  [EInitiativesDictionary.BIRTHDAY_CLUB]: 'Birthday club',
  [EInitiativesDictionary.GIFT_COINS]: 'Gift&nbsp;<s>cards</s>&nbsp;Coins',
  [EInitiativesDictionary.INVITATION_CAMPAIGN]: 'Invitation campaign',
  [EInitiativesDictionary.CUSTOMER_ACQUISITION]: 'Customer acquisition',
  [EInitiativesDictionary.SOCIAL_REWARDS]: 'Social rewards',

  [EInitiativesDictionary.PURCHASE_HISTORY_COMPLETED]: 'Completed',
  [EInitiativesDictionary.PURCHASE_HISTORY_PENDING]: 'Pending',
  [EInitiativesDictionary.PURCHASE_HISTORY_DISPUTED]: 'Disputed',
  [EInitiativesDictionary.PURCHASE_HISTORY_CANCELED]: 'Canceled',
  [EInitiativesDictionary.PURCHASE_HISTORY_WITH_REWARD_BONUS]:
    'With Reward Bonus',

  [EInitiativesDictionary.TRANSPARENT_SPECIAL_OFFER_STOREWIDE]: 'General offer',
  [EInitiativesDictionary.TRANSPARENT_SPECIAL_OFFER_PRODUCT_SERVICE]:
    'Specific discount',
  [EInitiativesDictionary.TRANSPARENT_SPECIAL_OFFER_BIRTHDAY]: 'Birthday offer',
  [EInitiativesDictionary.TRANSPARENT_SPECIAL_OFFER_TWO_FOR_ONE]: '2 for 1',

  [EInitiativesDictionary.SPECIAL_OFFER_STOREWIDE]: 'General offer',
  [EInitiativesDictionary.SPECIAL_OFFER_SPECIFIC]: 'Specific discount',
  [EInitiativesDictionary.SPECIAL_OFFER_BIRTHDAY]: 'Birthday offer',

  [EInitiativesDictionary.SPECIAL_COINS]: 'Offers',
  [EInitiativesDictionary.ACTIVE_PROGRAMS_REGULAR]: 'No deadline',
  [EInitiativesDictionary.ACTIVE_PROGRAMS_WARNING]: ''
};

export const InitiativeThemeDictionary = {
  [EInitiativesDictionary.DEFAULT]: {
    color: '#3E24D6',
    bg: '#F3F9FF',
    activeBg: '#3E24D6',
    activeColor: '#FFF'
  },
  [EInitiativesDictionary.APP_SIGNUP]: {
    color: '#3E24D6',
    bg: '#F3F9FF',
    activeBg: '#3E24D6',
    activeColor: '#FFF'
  },
  [EInitiativesDictionary.WIDGET_SIGNUP]: {
    color: '#3E24D6',
    bg: '#F3F9FF',
    activeBg: '#3E24D6',
    activeColor: '#FFF'
  },
  [EInitiativesDictionary.LOYALTY_AND_REWARDS]: {
    color: '#105A40',
    bg: '#D0F9E6',
    activeBg: '#105A40',
    activeColor: '#D0F9E6'
  },
  [EInitiativesDictionary.REFERRAL_PROGRAM]: {
    color: '#3C4048',
    bg: '#F1F2F6',
    activeBg: '#3C4048',
    activeColor: '#F1F2F6'
  },
  [EInitiativesDictionary.FREE_COINS]: {
    color: '#205BE0',
    bg: '#D9ECFF',
    activeBg: '#205BE0',
    activeColor: '#FFF'
  },
  [EInitiativesDictionary.WELCOME_COINS]: {
    color: '#205BE0',
    bg: '#D9ECFF',
    activeBg: '#205BE0',
    activeColor: '#FFF'
  },
  [EInitiativesDictionary.DEALS_AND_DISCOUNTS]: {
    color: '#EC7100',
    bg: '#FFFAF4',
    activeBg: '#EC7100',
    activeColor: '#FFF'
  },
  [EInitiativesDictionary.BIRTHDAY_CLUB]: {
    color: '#FA05A7',
    bg: '#FFFBFD',
    activeBg: '#FA05A7',
    activeColor: '#FFF'
  },
  [EInitiativesDictionary.GIFT_COINS]: {
    color: '#7C20BF',
    bg: '#EEEBFB',
    activeBg: '#7C20BF',
    activeColor: '#EEEBFB'
  },
  [EInitiativesDictionary.INVITATION_CAMPAIGN]: {
    color: '#B52831',
    bg: '#FFD9E0',
    activeBg: '#B52831',
    activeColor: '#FFF'
  },
  [EInitiativesDictionary.CUSTOMER_ACQUISITION]: {
    color: '#038B8F',
    bg: '#EDF9FA',
    activeBg: '#038B8F',
    activeColor: '#EDF9FA'
  },
  [EInitiativesDictionary.SOCIAL_REWARDS]: {
    color: '#8A3200',
    bg: '#FFECD4',
    activeBg: '#8A3200',
    activeColor: '#FFECD4'
  },
  [EInitiativesDictionary.PURCHASE_HISTORY_COMPLETED]: {
    color: '#105A40',
    bg: '#D0F9E6',
    activeBg: '#105A40',
    activeColor: '#FFF'
  },
  [EInitiativesDictionary.PURCHASE_HISTORY_PENDING]: {
    color: '#205BE0',
    bg: '#D9ECFF',
    activeBg: '#205BE0',
    activeColor: '#FFF'
  },
  [EInitiativesDictionary.PURCHASE_HISTORY_DISPUTED]: {
    color: '#8A3200',
    bg: '#FFECD4',
    activeBg: '#8A3200',
    activeColor: '#FFF'
  },
  [EInitiativesDictionary.PURCHASE_HISTORY_CANCELED]: {
    color: '#B52831',
    bg: '#FFD9E0',
    activeBg: '#B52831',
    activeColor: '#FFF'
  },
  [EInitiativesDictionary.PURCHASE_HISTORY_WITH_REWARD_BONUS]: {
    color: '#3C4048',
    bg: '#F1F2F6',
    activeBg: '#3C4048',
    activeColor: '#F1F2F6'
  },
  [EInitiativesDictionary.TRANSPARENT_SPECIAL_OFFER_STOREWIDE]: {
    color: 'transparent',
    bg: 'transparent',
    activeBg: 'transparent',
    activeColor: 'transparent'
  },
  [EInitiativesDictionary.TRANSPARENT_SPECIAL_OFFER_PRODUCT_SERVICE]: {
    color: 'transparent',
    bg: 'transparent',
    activeBg: 'transparent',
    activeColor: 'transparent'
  },
  [EInitiativesDictionary.TRANSPARENT_SPECIAL_OFFER_BIRTHDAY]: {
    color: 'transparent',
    bg: 'transparent',
    activeBg: 'transparent',
    activeColor: 'transparent'
  },
  [EInitiativesDictionary.TRANSPARENT_SPECIAL_OFFER_TWO_FOR_ONE]: {
    color: 'transparent',
    bg: 'transparent',
    activeBg: 'transparent',
    activeColor: 'transparent'
  },
  [EInitiativesDictionary.SPECIAL_OFFER_STOREWIDE]: {
    color: '#8A3200',
    bg: '#FFECD4',
    activeBg: '#EC7100',
    activeColor: '#FFF'
  },
  [EInitiativesDictionary.SPECIAL_OFFER_SPECIFIC]: {
    color: '#0044B2',
    bg: '#D9ECFF',
    activeBg: '#0044B2',
    activeColor: '#FFF'
  },
  [EInitiativesDictionary.SPECIAL_OFFER_BIRTHDAY]: {
    color: '#A4016E',
    bg: '#FBE6F5',
    activeBg: '#FA05A7',
    activeColor: '#FFF'
  },
  [EInitiativesDictionary.SPECIAL_COINS]: {
    color: '#A4016E',
    bg: '#FBE6F5',
    activeBg: '#A4016E',
    activeColor: '#FBE6F5'
  },
  [EInitiativesDictionary.ACTIVE_PROGRAMS_REGULAR]: {
    color: '#10222D',
    bg: '#FAFAFA',
    activeBg: '#FAFAFA',
    activeColor: '#10222D'
  },
  [EInitiativesDictionary.ACTIVE_PROGRAMS_WARNING]: {
    color: '#B96517',
    bg: '#FFFAF4',
    activeBg: '#FFFAF4',
    activeColor: '#B96517'
  }
};

// Initiative slugs missing from InitiativeThemeDictionary (e.g. Coin Store Twism,
// Twism Coins) fall back to DEFAULT so tags always render styled — same contract
// FilterByTags.getTheme enforces for the filter chips.
export const resolveInitiativeThemeStyle = (theme?: EInitiativesDictionary) => {
  const config =
    (theme && InitiativeThemeDictionary[theme]) ||
    InitiativeThemeDictionary[EInitiativesDictionary.DEFAULT];

  return {
    '--tag-color': config.color,
    '--tag-bg': config.bg,
    '--tag-active-bg': config.activeBg,
    '--tag-active-color': config.activeColor
  };
};
